import type {PageConfig} from '@app/types/next';
import {createContext} from '@deezer/react-utils';
import {getIsOauthFromPath} from './utils';

export type AppState = {
	appName: PageConfig['appName'];
	isOauth: boolean;
};

const [AppStateContextProvider, useAppState, AppStateContext] =
	createContext<AppState>({name: 'AppState'});

export type AppStateProviderProps = {
	appName: AppState['appName'];
	isOauth?: AppState['isOauth'];
	pathname?: string | null;
};

const AppStateProvider: React.FC<
	React.PropsWithChildren<AppStateProviderProps>
> = ({appName, isOauth, pathname, children}) => {
	const effectiveIsOauth = isOauth ?? getIsOauthFromPath(pathname ?? '');
	return (
		<AppStateContextProvider value={{appName, isOauth: effectiveIsOauth}}>
			{children}
		</AppStateContextProvider>
	);
};

export {AppStateProvider, useAppState, AppStateContext};
